export interface Functionality {
	title: string;
	description: string;
	descriptionTwo?: string;
	image: string;
	alt: string;
	link?: string;
	imagePosition?: 'left' | 'right';
}

export interface PricingPlan {
	index: number;
	title: string;
	price: number;
	unit: string;
	badge?: string;
	icon?: string;
	cardClass: string;
	buttonClass: string;
	buyed: boolean;
	path: string;
	features: { icon: string; text: string }[];
	button_text?: string;
}

export enum CardVirtual {
	AGENT_VIRTUAL = 'agent-virtual',
	CONSULTANT_VIRTUAL = 'consultant-virtual',
	DESIGN_VIRTUAL = 'designer-virtual',
}

export enum ProvaOra {
	PROVA_ORA = 'prova-ora'
}

/* export const FUNCTIONALITIES: Functionality[] = [
	{
		title: 'Ricerca Online di Immobili',
		description: `Trova l’<strong>immobile perfetto</strong> grazie a <strong>filtri avanzati</strong> e <strong>suggerimenti personalizzati</strong>. 
                    <strong>HomeAI</strong> ti offre una <strong>ricerca mirata</strong> e precisa, per risparmiare tempo e ottenere risultati migliori.`,
		image: 'image/search-property.svg',
		alt: 'Ricerca Online di Immobili',
		link: '/pricing',
		imagePosition: 'left',
	},
	{
		title: 'Stesura Automatica di Documenti Immobiliari',
		description: `Crea e gestisci tutti i <strong>documenti immobiliari</strong> necessari con semplicità. <strong>HomeAI</strong> automatizza la creazione di
                    <strong>contratti di locazione</strong>, <strong>vendite</strong> e <strong>proposte immobiliari</strong>, garantendo sempre un
                    <strong>risultato professionale</strong>.`,
		image: 'image/document-management.svg',
		alt: 'Stesura Documenti',
		link:  '/pricing',
		imagePosition: 'right',
	},
	{
		title: 'Database con Bot Intelligente per Immobili Disponibili',
		description: `Grazie a <strong>HomeAI</strong>, puoi interagire con un <strong>bot intelligente</strong> che ti aiuta a trovare gli
                    <strong>immobili disponibili</strong> nel nostro database. Il bot analizza le tue esigenze e suggerisce le migliori opzioni in tempo reale,
                    semplificando la tua ricerca.`,
		image: 'image/database-management.svg',
		alt: 'Database con Bot Intelligente',
		link:  '/pricing',
		imagePosition: 'left',
	},
]; */

export const FUNCTIONALITIES: Functionality[] = [
	{
		title: `Ricerca <span class="text-primary">Online</span>`,
		description: `HomAI <strong>rivoluziona la ricerca online di immobili grazie a filtri avanzati e suggerimenti intelligenti.</strong>
			Imposta i tuoi criteri(posizione, budget, caratteristiche, ecc.) e lascia che l'AI faccia il resto!`,
		image: 'image/search-property.svg',
		alt: 'Ricerca Online di Immobili',
		link: '/pricing',
		imagePosition: 'left',
	},
	{
		title: `Documenti e <span class="text-primary">Consulenza</span>`,
		description: `La burocrazia non è più un pstacolo grazie ad HomAI! <strong>La nostra intelligenza artificiale ti aiuta a generare automaticamente documenti come contratti
			di locazione, compravendita e proposte, riducendo al minimo errori e tempi di attesa!</strong> Ogni documento viene preparato seguendo le normative vigenti!`,
		image: 'image/document-management.svg',
		alt: 'Stesura Documenti',
		link:  '/pricing',
		imagePosition: 'right',
	},
	{
		title: `<span class="text-primary">DESIGN</span> DI INTERNI`,
		description: `Con HomeAI hai a disposizione un vero esperto di interior design virtuale! <strong>Descrivi le tue idee e lascia che l'AI ti proponga soluzioni per arredamento e decorazione!</strong>
		Il sistema può suggerire immagini di arredi che rispecchiano il tuo stile!`,
		image: 'image/database-management.svg',
		alt: 'Database con Bot Intelligente',
		link:  '/pricing',
		imagePosition: 'left',
	},
];

/* export const INFOSECTION: Functionality[] = [
	{
		title: 'LA ESACONS',
		description: `Il progetto <strong>EsaCons</strong> nasce con l’ambiziosa visione di sviluppare un’intelligenza artificiale avanzata, in grado di replicare le competenze di un esperto consulente immobiliare. EsaCons è progettata per fornire un supporto strategico e personalizzato, facilitando ogni fase delle attività immobiliari.`,
		image: 'image/robot-info.svg',
		alt: 'Robot AI EsaCons',
		imagePosition: 'left',
		descriptionTwo: '',
	},
	{
		title: 'LA NOSTRA MISSIONE',
		description: `L’obiettivo di <strong>EsaCons</strong> è offrire <strong>un assistente virtuale interattivo e intelligente</strong>, capace di affiancare gli utenti nella ricerca, nella compravendita e nella gestione della documentazione immobiliare. In un mercato in continua evoluzione, caratterizzato da normative complesse e dinamiche imprevedibili, EsaCons rappresenta <strong>una guida affidabile</strong> che aiuta a prendere decisioni informate, minimizzando rischi e ottimizzando ogni operazione.`,
		image: 'image/robot-mission.svg',
		alt: 'Robot su Smartphone EsaCons',
		imagePosition: 'right',
		descriptionTwo: `Grazie alla sua capacità di analisi e alla disponibilità di dati aggiornati, l'AI consente di superare le sfide del settore immobiliare con maggiore sicurezza, rapidità ed efficienza.`,
	},
]; */

export const INFOSECTION: Functionality[] = [
	{
		title: `CHI <span class="text-primary">SIAMO?</span>`,
		description: `<strong> La Esa-Consulting sviluppa piattaforme online  eapplicazioni!</strong>
		Offriamo servizi anche nel mondo del web marketing, <strong>compresa l'assistenza tecnica, la consulenza e la formazione per i suoi prodotti e servizi!</strong> `,
		image: 'image/robot-info.svg',
		alt: 'Robot AI EsaCons',
		imagePosition: 'left',
		descriptionTwo: '',
	},
	{
		title: 'LA NOSTRA <span class="text-primary">MISSIONE:</span>',
		description: `<strong>L’obiettivo di HomAI è offrire un assistente virtuale interattivo e intelligente</strong>, capace di affiancare gli utenti nella ricerca e
		 nella compravendita nel settore immobiliare. 
		 Grazie alla sua capacità di analisi e alla disponibilità di dati aggiornati, 
		 <strong>l'AI consente di superare le sfide del settore immobiliare con maggiore sicurezza, rapidità ed efficienza.</strong>`,
		image: 'image/robot-mission.svg',
		alt: 'Robot su Smartphone EsaCons',
		imagePosition: 'right',
		descriptionTwo: ``,
	},
];

/* export const PRICING: Functionality[] = [
	{
		title: 'ACCESSO INTELLIGENTE AL MERCATO IMMOBILIARE',
		description: `EsaCons ti offre un <strong>accesso immediato </strong> alle risorse più aggiornate del settore immobiliare. Consulta annunci di vendita e locazione, analizza tendenze di mercato e ricevi suggerimenti personalizzati grazie alla nostra intelligenza artificiale avanzata. Semplifica la ricerca e ottimizza le tue decisioni con un assistente su misura per te.`,
		image: 'image/ai-hand.svg',
		alt: 'AI con smartphone',
		imagePosition: 'right',
	},
	{
		title: 'SUPPORTO STRATEGICO PER OGNI DECISIONE',
		description:
			'Con EsaCons hai sempre a disposizione <strong> informazioni dettagliate </strong> e strategie personalizzate per la compravendita immobiliare. La nostra AI analizza il mercato in tempo reale, fornisce insight strategici e ti aiuta a prendere decisioni più sicure ed efficienti, riducendo i rischi e massimizzando le opportunità.',
		image: 'image/ai-mobile.svg',
		alt: 'AI su smartphone',
		imagePosition: 'left',
	},
]; */

export const PRICING: Functionality[] = [
	{
		title: `<span class="text-primary">Semplifica</span> la tua esperienza`,
		description: `<strong>Semplifica la ricerca e ottimizza le tue decisioni con un assistente su misura per te!</strong>
		HomAI ti offre un accesso immediato alle risorse più aggiornate del settore immobiliare.`,
		image: 'image/ai-hand.svg',
		alt: 'AI con smartphone',
		link: '/how-it-works',
		imagePosition: 'right',
	},
	{
		title: `<span class="text-primary">Velocizza</span> le tue operazioni`,
		description:
			`<strong>La nostra AI analizza il mercato in tempo reale, fornisce insight strategici e ti aiuta a prendere decisioni più sicure ed efficienti,</strong>
			 riducendo i rischi e massimizzando le opportunità.`,
		image: 'image/ai-mobile.svg',
		alt: 'AI su smartphone',
		imagePosition: 'left',
	},
];

export const PRICINGPLAN: PricingPlan[] = [
	/* {
		index: 0,
		title: 'HomAI Junior',
		price: 0,
		unit: '/ FOREVER',
		cardClass: 'shadow-sm p-4 text-center w-100 d-flex flex-column',
		buttonClass: 'btn  w-100 mt-3 fw-bold btn-table-pricing',
		path: 'prova-ora',
		buyed: false,
		features: [
			 {
				icon: 'bi bi-check-circle-fill text-secondary me-2',
				text: '?',
			},
			{
				icon: 'bi bi-check-circle-fill text-secondary me-2',
				text: '?',
			}, 
		],
		button_text: 'OTTIENI LA VERSIONE GRATUITA'
	}, */
	{
		index: 0,
		title: 'Radar Immobiliare',
		price: 0,
		unit: '',
		badge: "BEST!",
		icon: '',
		cardClass:
			'shadow-sm p-4 text-center border-primary w-100 d-flex flex-column',
		buttonClass: 'btn  w-100 mt-3 fw-bold btn-table-pricing',
		path: 'agent-virtual',
		buyed: false,
		features: [
			{
				icon: 'bi bi-check-circle-fill text-warning me-2',
				text: 'Ricerca immobiliare online',
			},
			{
				icon: 'bi bi-check-circle-fill text-warning me-2',
				text: 'Risultati pertinenti in base a località, prezzo e caratteristiche',
			},
			{
				icon: 'bi bi-check-circle-fill text-warning me-2',
				text: 'Suggerimenti personalizzati sulla base delle tue esigenze',
			},
		],
		button_text: 'USA SUBITO'
	},
	{
		index: 1,
		title: 'Pratiche Facili',
		price: 15,
		unit: '/ MESE',
		cardClass: 'shadow-sm p-4 text-center w-100 d-flex flex-column',
		buttonClass: 'btn  w-100 mt-3 fw-bold btn-table-pricing',
		path: 'consultant-virtual',
		buyed: false,
		features: [
			{
				icon: 'bi bi-check-circle-fill text-purple me-2',
				text: 'Generazione automatica di documenti',
			},
			{
				icon: 'bi bi-check-circle-fill text-purple me-2',
				text: 'Contratti e proposte personalizzate per locazione, acquisto e vendita',
			},
			{
				icon: 'bi bi-check-circle-fill text-purple me-2',
				text: `Modelli adattati dinamicamente in base alle risposte dell'utente`,
			},
			{
				icon: 'bi bi-check-circle-fill text-purple me-2',
				text: 'Consulenza guidata durante la compilazione',
			}
		],
	},
	{
		index: 2,
		title: 'Interni da Sogno',
		price: 20,
		unit: '/ MESE',
		icon: '',
		cardClass: 'shadow-sm p-4 text-center w-100 d-flex flex-column',
		buttonClass: 'btn  w-100 mt-3 fw-bold btn-table-pricing',
		path: 'designer-virtual',
		buyed: false,
		features: [
			{
				icon: 'bi bi-check-circle-fill text-purple me-2',
				text: 'Progettazione di interni con creazione di immagini',
			},
			{
				icon: 'bi bi-check-circle-fill text-purple me-2',
				text: 'Concept grafici personalizzati per ogni ambiente',
			},
			{
				icon: 'bi bi-check-circle-fill text-purple me-2',
				text: 'Suggerimenti visivi per colori, arredi e stile',
			}/* ,
			{
				icon: 'bi bi-check-circle-fill text-purple me-2',
				text: `Ideazione di layout e ambientazioni con l'assistenza di esperti virtuali`,
			} */
		],
	},
];
